/*
 *  This has been generated using the Synergy STDev tool.
 *  Any modifications will be lost after the next build
 */
import * as st from './STApp'
import { componentApi, loadTranslations } from 'common'


export class IACMenuApi {
  async LoadIntegratedActions(boid : string) : Promise<any> {
    return await componentApi.call('st', 'st-iac-menu', 'IACMenuApi', 'LoadIntegratedActions', {
      boid,
    });
  }
}
export default new IACMenuApi()
